import { useState } from "react";

import PersonIcon from '@mui/icons-material/Person';

import { LoadingSpinner } from "../../../../../common/Loading";
import { CandidateDetailsModal } from "./CandidateDetailsModal";

export const EmployeeListViewModal = ({ data, mrfStatus, mrfId, onUpdateCandidate, showGeneralMessage }) => {
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [loading, setLoading] = useState(false);

  const openModal = (employee) => setSelectedCandidate(employee);

  return (
    <>
      <div className="border border-gray-300 rounded-lg bg-white mb-4">
        <div className="py-2 border-b border-gray-300 text-center"><h3 className="font-medium text-gray-700">Recruitment Summary</h3></div>
        <div className="py-3 px-2 grid grid-cols-3 gap-2">
            <div className="text-center p-2 bg-blue-50 rounded-lg"><p className="text-xl font-bold text-blue-600 m-0">{data.length}</p><p className="text-xs text-gray-600 m-0">Total</p></div>
            <div className="text-center p-2 bg-green-50 rounded-lg"><p className="text-xl font-bold text-green-600 m-0">{data.filter(emp => emp.isAccepted).length}</p><p className="text-xs text-gray-600 m-0">Accepted</p></div>
            <div className="text-center p-2 bg-red-50 rounded-lg"><p className="text-xl font-bold text-red-600 m-0">{data.filter(emp => emp.isDeclined).length}</p><p className="text-xs text-gray-600 m-0">Declined</p></div>
        </div>
      </div>

      <div className="border border-gray-300 rounded-lg bg-white">
        <div className="pt-2 pb-1 px-4 border-b border-gray-300"><h3 className="font-medium text-gray-700">Employee List</h3></div>
        <div className="p-4">
        {data.length === 0 ? (
          <div className="text-center py-10"><PersonIcon className="w-10 h-10 text-gray-300" /><p className="text-gray-500">No Candidates Available</p></div>
        ) : (
          data.map((emp) => (
            <div key={emp.id} onClick={() => openModal(emp)} className="flex items-center justify-between p-3 border border-gray-200 rounded-lg mb-2 hover:bg-gray-50 cursor-pointer shadow-sm">
                <div className="flex items-center space-x-3">
                  <div className="w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center font-semibold text-blue-600">{emp.fullName[0]}</div>
                  <div><h4 className="font-medium text-sm m-0">{emp.fullName}</h4><p className="text-xs text-gray-500 m-0 truncate w-32">{emp.skills}</p></div>
                </div>
                <div className={`text-xs px-2 py-1 rounded font-medium ${emp.isAccepted ? 'bg-green-100 text-green-700' : emp.isDeclined ? 'bg-red-100 text-red-700' : 'bg-blue-100 text-blue-700'}`}>
                  {emp.isAccepted ? 'Accepted' : emp.isDeclined ? 'Declined' : 'Waiting'}
                </div>
            </div>
          ))
        )}
        </div>
      </div>
      {selectedCandidate && (
        <CandidateDetailsModal
          visible={!!selectedCandidate} onClose={() => setSelectedCandidate(null)} mrfStatus={mrfStatus} candidate={selectedCandidate}
          setLoading={setLoading} showGeneralMessage={showGeneralMessage} onCandidateUpdate={(updated) => onUpdateCandidate(mrfId, updated.id, updated)}
        />
      )}
      <LoadingSpinner loading={loading} />
    </>
  );
};